import classNames from 'classnames';
import CustomTooltip, { ICustomTooltipProps, TOOLTIP_TYPE } from '../CustomTooltip/CustomTooltip';
import Icon from '../Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { copyToBuffer } from 'src/utils/helpers';

interface IProps {
  data?: string | number;
  tooltipMessage?: string;
  tooltipProps?: Partial<ICustomTooltipProps>;
  size?: number;
  className?: string;
}

const CopyButton = (props: IProps): JSX.Element => {
  const onCopy = () => {
    copyToBuffer(props.data);
  };

  const copyBtnClassName = classNames('color-mainblue text-size-20 cursor-pointer', props.className);

  return props.tooltipMessage ? (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <CustomTooltip type={TOOLTIP_TYPE.COPY} copyData={props.data} message={props.tooltipMessage} {...props.tooltipProps}>
      <Icon name={Icons.Copy} size={props.size} className={copyBtnClassName} />
    </CustomTooltip>
  ) : (
    <Icon name={Icons.Copy} size={props.size} onPress={onCopy} className={copyBtnClassName} />
  );
};

export default CopyButton;
